import {getLead} from "@project/sdk/sales";
import {GetLeadResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {leadKeys} from "../../../lead-keys";

export function getLeadQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...leadKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetLeadResponse.parse(await getLead(id, {includeDeleted}, {signal})),
  });
}
